import { VerifiedIcon } from "@/components/UI/VerifiedIcon";
import { nFormatter } from "@/common/utils/parseNumber";
import { useNavigate } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import { useUserSubscription } from "@/common/hooks/useUserSubscription";
import { useCallback } from "react";
import "./ProfileCard.scss";
import { Avatar } from "@rg/ui/components/Avatar";
import { Button } from "@rg/ui/components/Button";

interface IProfileCard {
  userName: string;
  verified: boolean;
  isStudio: boolean;
  hasSubscribeMsg?: boolean;
  followers: number;
  profileImageUrl: string | null;
  highlightText?: React.ReactElement;
  userId: string;
  onClick?: () => void;
}

export const ProfileCard = ({
  userName,
  verified,
  isStudio,
  followers,
  profileImageUrl,
  userId,
  highlightText,
  onClick,
  hasSubscribeMsg
}: IProfileCard) => {
  const navigate = useNavigate();
  const { subscribed, subscribe, unsubscribe } = useUserSubscription(userId, !!hasSubscribeMsg);

  const handleClick = useCallback(() => {
    if (onClick) {
      onClick();
    }

    navigate(routes.user(userId));
  }, [navigate, onClick, userId]);

  const handleSubscribe = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      subscribed ? unsubscribe() : subscribe();
    },
    [subscribed, unsubscribe, subscribe]
  );

  return (
    <div onClick={handleClick} aria-label={`Link to ${userName} profile`} className="profileCard">
      <div className="profileCardImageWrap">
        <Avatar src={profileImageUrl ?? undefined} alt={`Poster for ${userName}`} size="md" />
      </div>
      <div className="profileCardInfo">
        <div className="profileCardUserName">
          <span className="userName">{highlightText ?? userName ?? userId}</span>
          {verified && <VerifiedIcon isStudio={isStudio} title={`${userName} is a verified RedGIFs ${isStudio ? "Channel" : "creator"}`} />}
        </div>
        <div className="profileCardFollowers">
          {nFormatter(followers)} followers
        </div>
      </div>
      <div className="profileCardFollowBtnWrap">
        <Button
          onClick={handleSubscribe}
          className="profileCardFollowBtn"
          variant="secondary"
          size="sm"
        >
          {subscribed ? "Unfollow" : "Follow"}
        </Button>
      </div>
    </div>
  );
};
